export const isProductionImpersonationHost = () =>
  /^iportal-(?:nl|ru)\.servers\.com$/.test(window.location.hostname);
